import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRunShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRunShortcut"><Path d="M9.5 17.5L14.5 6.5M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRunShortcut;
